import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2","key":"svg-0"}],["path",{"d":"M10 9v-6l4 6v-6","key":"svg-1"}]]

/**
 * IconNavigationNorth
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbmF2aWdhdGlvbi1ub3J0aCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTYgMjFsLTQgLThsLTQgOGw0IC0ybDQgMiIgLz4KICA8cGF0aCBkPSJNMTAgOXYtNmw0IDZ2LTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/navigation-north
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNavigationNorth = createReactComponent('outline', 'navigation-north', 'NavigationNorth', __iconNode);

export default IconNavigationNorth;